import { createGlobalStyle } from 'styled-components/macro';
import RobotoBold from '../assets/fonts/Roboto-Bold.ttf';
import RobotoCondensedBold from '../assets/fonts/Roboto-BoldCondensed.ttf';
import RobotoMedium from '../assets/fonts/Roboto-Medium.ttf';
import RobotoRegular from '../assets/fonts/Roboto-Regular.ttf';

export default createGlobalStyle`
  body {
    padding: 0;
    margin: 0;
    font-family: RobotoMedium, sans-serif;
  }
  // Хак для правильного отображения клавиатуры на странице ввода телефона
  .keyboard-small__phone {
    top: 28% !important;
    right: 15% !important;
  }

  // Хак для правильного отображения клавиатуры для модалки входа в родительский контроль
  .keyboard-small__pin {
    top: 38% !important;
    right: 15% !important;
  }
  
  @font-face {
    font-family: RobotoBold;
    src: url('${RobotoBold}') format('truetype');
  }
  
  @font-face {
    font-family: RobotoCondensedBold;
    src: url('${RobotoCondensedBold}') format('truetype');
  } 
  
  @font-face {
    font-family: RobotoMedium;
    src: url('${RobotoMedium}') format('truetype');
  }
  
  @font-face {
    font-family: RobotoRegular;
    src: url('${RobotoRegular}') format('truetype');
  }
`;
